import styled,{css} from "styled-components";
import { Controller } from 'react-hook-form';

const TextFormInput = ({
  name,
  containerClassName: containerClass,
  inputWidth,
  control,
  id,
  label,
  labelClassName: labelClass,
  ...other
}) => {
  return (
    <Controller
      name={name}
      defaultValue={''}
      control={control}
      render={({ field }) => (
        <FormGroup width={inputWidth}>
          {label && (typeof label === 'string' ? (
            <FormLabel htmlFor={id ?? name} className={labelClass}>
              {label}
            </FormLabel>
          ) : (
            <>{label}</>
          ))}
          <FormControl iname={name} {...other} {...field} />
        </FormGroup>
      )}
    />
  );
};

export default TextFormInput;

const FormGroup = styled.div `
  display: block;
width: ${(props) =>  css`calc(${props.width} - 20px)` || "100%"};

`
const FormLabel = styled.label `
display: block;
color: ${({ theme }) => theme.color};
font-size: 14px;
margin-bottom: 8px;
`

const FormControl = styled.input `
width: 100%;
height: 52px;
border-radius: 8px;
border: ${({ theme }) => `1px solid ${theme.cardStroke}`};
background-color: ${({ theme }) => theme.inputbg};
color: ${({ theme }) => theme.color};
padding: 2px 6px;
box-sizing: border-box;
`